import { useEffect, useState } from "react";
import { hub, type AuditEntry } from "@/lib/hub";

// What happened in the hub (owners): sign-ins, refused sign-ins, user and permission changes. Kept 400 days.
// Changes to a website's content are in that website's History.

const when = (iso: string) => new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export function Activity() {
  const [entries, setEntries] = useState<AuditEntry[] | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    hub.audit(200).then(setEntries, (e: unknown) => setError(e instanceof Error ? e.message : "Couldn't load the activity."));
  }, []);
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight">Activity</h1>
      <p className="mt-2 mb-6 text-midnight/70">Sign-ins and changes to users and permissions, newest first.</p>
      {error && <p className="text-red-800">{error}</p>}
      {!entries && !error && <p className="text-midnight/70">Loading…</p>}
      {entries && (
        <ul className="flex flex-col gap-2">
          {entries.map((e) => (
            <li key={e.id} className="rounded-xl border border-midnight/10 bg-sand px-4 py-3 text-sm">
              <div className="flex flex-wrap justify-between gap-x-4">
                <span className="font-bold">{e.action}</span>
                <span className="font-mono text-xs text-midnight/70">{when(e.at)}</span>
              </div>
              <p className="break-all text-midnight/80">
                {e.email}
                {e.detail && ` · ${e.detail}`}
              </p>
            </li>
          ))}
          {!entries.length && <li className="text-midnight/70">Nothing yet.</li>}
        </ul>
      )}
    </div>
  );
}
